import * as React from 'react';
import Box from '@mui/joy/Box';
import Sheet from '@mui/joy/Sheet';
import Stack from '@mui/joy/Stack';
import AvatarWithStatus from './AvatarWithStatus';
import ChatBubble from './ChatBubble';
import MessageInput from './MessageInput';
import MessagesPaneHeader from './MessagesPaneHeader';


export default function MessagesPane(props) {
  const { selectedChatId, sendCustomMessage, sucursal_id, agent_name, chatMessages, setChatMessages, conversation, getConversation, updateConversation, getUserMessages} = props;
  const messagesEndRef = React.useRef(null);
  const messagesContainerRef = React.useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  React.useEffect(() => {
    if (selectedChatId) {
        getConversation(selectedChatId, props.tenant_id, props.sucursal_id);
        getUserMessages(selectedChatId, props.tenant_id, props.sucursal_id, props.conversation_id);
        const interval = setInterval(() => {
          if (selectedChatId) {
            props.getUserMessages(selectedChatId, props.tenant_id, props.sucursal_id, props.conversation_id);
          }
        }
        , 30000);
        return () => clearInterval(interval);
      }
  }, [selectedChatId]);

  React.useEffect(() => {
    if (props.userMessages) {
      // reverse the order of the messages
    setChatMessages(props.userMessages.reverse());
    }
  }, [props.userMessages]);
  return (
    <Sheet
      sx={{
        height: { xs: 'calc(100dvh - var(--Header-height))', md: '92dvh' },
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'background.level1',
      }}
    >
      <MessagesPaneHeader name={props.selectedChat?.user_profile} username={props.selectedChat?.user_id} />
      <Box
        ref={messagesContainerRef}
        sx={{
          display: 'flex',
          flex: 1,
          minHeight: 0,
          px: 2,
          py: 3,
          overflowY: 'scroll',
          flexDirection: 'column-reverse',
        }}
      >
        <Stack spacing={2} sx={{ justifyContent: 'flex-end' }}>
          {chatMessages.map((message, index) => {
            const isYou = message.send === true
            return (
              <Stack
                key={index}
                direction="row"
                spacing={2}
                sx={{ flexDirection: isYou ? 'row-reverse' : 'row' }}
              >
                {message.sender !== 'You' && (
                  <AvatarWithStatus
                    online={message?.sender?.online}
                    src={message?.sender?.avatar}
                  />
                )}
                <ChatBubble variant={isYou ? 'sent' : 'received'} {...message} />
              </Stack>
            );
          })}
          <div ref={messagesEndRef} />
        </Stack>
      </Box>
      <MessageInput
        sendCustomMessage={sendCustomMessage}
        getUserMessages={props.getUserMessages}
        selectedChatId={selectedChatId}
        tenant_id={props.tenant_id}
        sucursal_id={sucursal_id}
        agent_name={agent_name}
        conversation_id={props.conversation_id}
        scrollToBottom={scrollToBottom}
        conversation={conversation}
        getConversation={getConversation}
        updateConversation={updateConversation}
      />
    </Sheet>
  );
}